import SectionHeaderPreview from './SectionHeaderPreview.vue';
import ClinicBrandingPreview from './ClinicBrandingPreview.vue';
import NoteHelpPreview from './NoteHelpPreview.vue';
import ImagePreview from './ImagePreview.vue';
import ShortResponsePreview from './ShortResponsePreview.vue';
import LongResponsePreview from './LongResponsePreview.vue';
import DescriptionPreview from './DescriptionPreview.vue';
import EmailPreview from './EmailPreview.vue';
import PhonePreview from './PhonePreview.vue';
import SingleSelectionPreview from './SingleSelectionPreview.vue';
import MultiSelectionPreview from './MultiSelectionPreview.vue';
import DropdownPreview from './DropdownPreview.vue';
import CheckboxPreview from './CheckboxPreview.vue';
import YesNoPreview from './YesNoPreview.vue';
import DatePreview from './DatePreview.vue';
import DateTimePreview from './DateTimePreview.vue';
import TimePreview from './TimePreview.vue';
import NumericPreview from './NumericPreview.vue';
import RatingPreview from './RatingPreview.vue';
import SignerPreview from './SignerPreview.vue';
import DefaultPreview from './DefaultPreview.vue';

export {
  SectionHeaderPreview,
  ClinicBrandingPreview,
  NoteHelpPreview,
  ImagePreview,
  ShortResponsePreview,
  LongResponsePreview,
  DescriptionPreview,
  EmailPreview,
  PhonePreview,
  SingleSelectionPreview,
  MultiSelectionPreview,
  DropdownPreview,
  CheckboxPreview,
  YesNoPreview,
  DatePreview,
  DateTimePreview,
  TimePreview,
  NumericPreview,
  RatingPreview,
  SignerPreview,
  DefaultPreview
};

/**
 * Map element types to their preview components
 */
export const previewComponentMap = {
  'section-header': SectionHeaderPreview,
  'clinic-branding': ClinicBrandingPreview,
  'note-help': NoteHelpPreview,
  'image': ImagePreview,
  'short-response': ShortResponsePreview,
  'long-response': LongResponsePreview,
  'description': DescriptionPreview,
  'email': EmailPreview,
  'phone': PhonePreview,
  'single-selection': SingleSelectionPreview,
  'multi-selection': MultiSelectionPreview,
  'dropdown': DropdownPreview,
  'checkbox': CheckboxPreview,
  'yes-no': YesNoPreview,
  'date': DatePreview,
  'datetime': DateTimePreview,
  'time': TimePreview,
  'numeric': NumericPreview,
  'rating': RatingPreview,
  'signer': SignerPreview
};

/**
 * Get the preview component for a given element type
 * @param {string} type - The element type
 * @returns {Object} - The preview component
 */
export function getPreviewComponent(type) {
  return previewComponentMap[type] || DefaultPreview;
}

export default {
  SectionHeaderPreview,
  ClinicBrandingPreview,
  NoteHelpPreview,
  ImagePreview,
  ShortResponsePreview,
  LongResponsePreview,
  DescriptionPreview,
  EmailPreview,
  PhonePreview,
  SingleSelectionPreview,
  MultiSelectionPreview,
  DropdownPreview,
  CheckboxPreview,
  YesNoPreview,
  DatePreview,
  DateTimePreview,
  TimePreview,
  NumericPreview,
  RatingPreview,
  SignerPreview,
  DefaultPreview,
  previewComponentMap,
  getPreviewComponent
};
